import * as React from "react";
import DialogContentText from "@mui/material/DialogContentText";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

import { RFHTextField as RHFTextField } from '../../RFH'
import { updateIsLock } from "../../../sevices/apiEpic";
import { useCustomSearchParams } from "../../../hooks/useCustomSearchParams";
import { useResponsive } from "../../../hooks/useResponsive";
import useMutate from "../../../hooks/useMutate";
import "./../milestone.scss";
import FormDialog from "../../Dialog/FormDialog";
import useBoardIdByKey from "../../../hooks/useBoardIdByKey";

export default function ConfirmationLock({
  message,
  open,
  handleClose,
  callback,
  title,
  btnTitle,
  is_locked,
}) {
  const [milestone, setMilestone] = useCustomSearchParams("milestone");
  const { id } = useBoardIdByKey();
  const queryClient = useQueryClient();
  const isMobile = useResponsive("down", "md");

  const methods = useForm({
    resolver: yupResolver(
      yup.object({
        comment: yup.string().required("Comment is required"),
      })
    ),
  });

  const { mutate, isPending } = useMutate(updateIsLock, [], () => {
    queryClient.invalidateQueries({
      queryKey: ["epic_id", milestone],
    });
    queryClient.invalidateQueries({
      queryKey: ["milestone_history", milestone],
    });
    queryClient.invalidateQueries({
      queryKey: ["epic", `${id}`],
    });
    callback();
    methods.setValue("comment", "");
  });

  const onSubmit = (formData) => {
    mutate({
      epic_id: milestone,
      board_id: id,
      data: {
        is_locked: !is_locked,
        comment: formData.comment,
      },
    });
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <FormDialog
            open={open}
            handleClose={handleClose}
            handleSubmit={methods.handleSubmit(onSubmit)}
            title={title}
            buttonTxt={btnTitle}
            width={470}
            isLoading={isPending}
            cancelBtn={true}
            className="confirm-lock-dialog"
            fullWidth={true}>
            <DialogContentText
              id="alert-dialog-slide-description"
              className={isMobile ? "mobile-font" : ""}>
              {message}
              <RHFTextField
                name="comment"
                sx={{ marginTop: isMobile ? "" : "8px" }}
                multiline
                rows={4}
              />
            </DialogContentText>
          </FormDialog>
        </form>
      </FormProvider>
    </React.Fragment>
  );
}
